import { useRecoilState } from 'recoil'

import { soundState } from '../recoil/atoms/appAtom'

export const useRecoilSound = () => {
  const [sound, setSound] = useRecoilState(soundState)
  return {
    sound: sound,
    setSound: setSound,
  }
}
